import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from 'moment'
import "./styles.css";

class Start extends Component {
  render() {
    const {
      completedInARow,
      totalCompleted,
      programStarted,
      dayEntries
    } = this.props;
    const todayEntry = Object.keys(dayEntries).find((entry) => {
      return new Date(entry).toDateString() === new Date().toDateString()
    })

    let completed = false;
    if (todayEntry) {
      completed = dayEntries[todayEntry][0].complete
    }

    return (
      <div className="start">
        <div className="middle">
          <div className="top">
            <div className="lotus">
              <img src="/imgs/lotus-start-1.svg" alt="начало" />
            </div>
            <span className="color-blue-sky">Начало:</span>
            {programStarted && (
              <span>
                {new Date(programStarted).toLocaleDateString("bg-BG")}
              </span>
            )}
          </div>
          <div className="start-bttn-cell">
            <Link to="/questionnaire/1" className="start-bttn">
              <span className="c1">
                <div className="start-bttn-text">{completed ? "Редактирай" : "Започни"}</div>
              </span>
              <span className="c2" />
              <span className="c3" />
            </Link>
          </div>
          <div className="bottom">
            <div className="lotus">
              <img src="/imgs/lotus.svg" alt="" />
            </div><span className="color-blue-sky">Дни общо:</span>
            {totalCompleted}
          </div>
        </div>

        <div className="right">
          <div className="lotus">
            <img src="/imgs/lotus-start-2.svg" alt="дни" />
          </div><span className="color-blue-sky">Дни подред:</span>
          <div className="inarow">
            {completedInARow}
          </div>
        </div>
      </div>
    );
  }
}
const mstp = state => ({
  completedInARow: state.user.payload.completedInARow,
  totalCompleted: state.user.payload.totalCompleted,
  programStarted: state.user.payload.programStarted,
  dayEntries: state.user.payload.dayEntries
});

export default connect(mstp)(Start);



// WEBPACK FOOTER //
// ./src/components/Start/Start.js